import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, Pagination } from "swiper/modules"
import Link from "next/link"
import "swiper/css"
import "swiper/css/pagination"
import { StyledSliderImage } from "../styled/ProductSlider"
import { PublicProductBannersQuery } from "@generated/graphql"

interface IProductBanners {
  banners?: PublicProductBannersQuery["publicProductBanners"]
}

export default function ProductBanners({ banners }: IProductBanners) {

  return banners && banners.length > 0 ? <Swiper
    autoplay={{
      delay: 10000,
    }}
    loop={true}
    allowTouchMove={true}
    modules={[Autoplay, Pagination]}
    slidesPerView={1}
    centeredSlides={true}
    className="activity-swiper">
    {banners.map((banner, index) => <SwiperSlide key={banner.id}>
      <Link href={banner.destinationUrl}>
        <StyledSliderImage alt={`Banner ${index}`} src={banner.image || "/assets/img/logo.png"} width={1280} height={500} />
      </Link>
    </SwiperSlide>)}
  </Swiper>
    : null
}
